import { combineEpics } from 'redux-observable'
import AlgoliaEpics from './algolia'
import AppEpics from './app'
const epicList = [...AlgoliaEpics, ...AppEpics]
export default combineEpics(...epicList)